import type { PackageInfo, SuspiciousAppInfo } from '../types/types';

// parses base64-encoded malware data to SuspiciousAppInfo[]
export const parseMalwareData = async (data: string[]): Promise<SuspiciousAppInfo[]> => {
  return new Promise((resolve, reject) => {
    try {
      const suspiciousAppData = data.map((entry) => toSuspiciousAppInfo(entry));
      resolve(suspiciousAppData);
    } catch (error: any) {
      reject(`Parsing app data failed: ${error}`);
    }
  });
};

export const toSuspiciousAppInfo = (base64Value: string): SuspiciousAppInfo => {
  const data = JSON.parse(atob(base64Value));
  const packageInfo = data.packageInfo as PackageInfo;
  return {
    packageInfo,
    reasons: data.reasons,
    permissions: data.permissions,
  } as SuspiciousAppInfo;
};
